module.exports = __webpack_public_path__ + "static/media/MHRM89N0001.a506de98.svg";